import React from 'react';
import { array, oneOf } from 'prop-types';

import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { types as sdkTypes } from '../../util/sdkLoader';
import { propTypes } from '../../util/types';
import { ledgerRows, ledgerLabelId, labelVoidNotes } from '../../util/ledgerLines';

import css from './OrderBreakdown.module.css';

const { Money } = sdkTypes;

/**
 * What happened to the order's money after checkout, as its line items say:
 * refunds and what was kept back, fees returned, labels, carrier adjustments,
 * a bank dispute. Only this side's lines; the total below already includes them.
 *
 * Under a seller's label row, a label whose void is still with the carrier (its cost comes
 * back once the carrier approves) or was refused by it (it stays charged).
 */
const LineItemLedgerMaybe = props => {
  const { lineItems, role, voidedLabels, intl } = props;
  const rows = ledgerRows(lineItems, role);
  if (!rows.length) return null;
  const notes = role === 'provider' ? labelVoidNotes(voidedLabels) : [];
  return (
    <>
      {rows.map(row => {
        const rowNotes = notes.filter(note => note.code === row.code);
        return (
          <div key={row.code} className={css.lineItem}>
            <span className={css.itemLabel}>
              <FormattedMessage id={ledgerLabelId(row.code, role)} />
              {rowNotes.map((note, index) => (
                <span key={index} className={css.labelVoidNote}>
                  <FormattedMessage
                    id={
                      note.status === 'requested'
                        ? 'OrderBreakdown.labelVoidRequested'
                        : 'OrderBreakdown.labelVoidRejected'
                    }
                    values={{ amount: formatMoney(intl, new Money(note.cents, row.currency)) }}
                  />
                </span>
              ))}
            </span>
            <span className={css.itemValue}>{formatMoney(intl, new Money(row.amount, row.currency))}</span>
          </div>
        );
      })}
    </>
  );
};

LineItemLedgerMaybe.propTypes = {
  lineItems: propTypes.lineItems.isRequired,
  role: oneOf(['customer', 'provider']).isRequired,
  // The order's protectedData.voidedLabels
  voidedLabels: array,
  intl: intlShape.isRequired,
};

export default LineItemLedgerMaybe;
